import { createTheme } from "@mui/material/styles";


export const customTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#313131',
        },
        secondary: {
            main: '#fbc02d',
        },
        divider: 'rgba(255,160,0,0.31)',
    },
});